import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { DateFormats, NebulaDateService } from '../nebula-date/nebula-date.service';

@Injectable()
export class NebulaDateAdapter extends NativeDateAdapter {
  constructor(platform: Platform, private nebulaDate: NebulaDateService) {
    super(arguments[2], platform);
  }

  format(date: Date, displayFormat: { [key in 'day' | 'month' | 'year']: 'numeric' | 'short' | 'long' }): string {
    if (displayFormat.day === 'numeric' && displayFormat.month === 'short' && displayFormat.year === 'numeric') {
      return this.nebulaDate.format(date);
    } else if (displayFormat.month === 'short' && displayFormat.year === 'numeric') {
      return this.nebulaDate.format(date, DateFormats.YearShortMonth);
    } else if (displayFormat.month === 'long' && displayFormat.year === 'numeric') {
      return this.nebulaDate.format(date, DateFormats.YearMonth);
    } else {
      return super.format(date, displayFormat);
    }
  }

  parse(value: any): Date {
    return this.nebulaDate.parse(value);
  }

  getMonthNames(style: 'long' | 'short' | 'narrow'): string[] {
    if (style === 'short') {
      return new Array(12).fill(null).map((e, i) => this.nebulaDate.format(new Date(2019, i, 2), 'LLL'));
    } else {
      return super.getMonthNames(style);
    }
  }

  getFirstDayOfWeek(): number {
    return this.nebulaDate.getFirstDayOfWeek();
  }
}
